import React from "react"

export default function Anchor(props: { anchorId: string }) {
  return (
    <div id={props.anchorId}></div>
  );
}
